import type { Range } from '@/types/stats.types'

export const AGE_RANGES: Range[] = [
  { label: '18-24', max: 24, min: 18 },
  { label: '25-34', max: 34, min: 25 },
  { label: '35-44', max: 44, min: 35 },
  { label: '45-64', max: 64, min: 45 },
  { label: '65+', max: Infinity, min: 65 },
]

export const INCOME_RANGES: Range[] = [
  { label: '$50,000 - $79,999', max: 79999, min: 50000 },
  { label: '$80,000 - $99,999', max: 99999, min: 80000 },
  { label: '$100,000 - $149,999', max: 149999, min: 100000 },
  { label: '$150,000 - $199,999', max: 199999, min: 150000 },
  { label: '$200,000 or more', max: Infinity, min: 200000 },
]
